export const businessInfo = {
  name: "K Bakery",
  phone: "+1 403-360-3664",
  email: "kbakery1002@gmail.com",
  address: {
    street: "2541 Fairway Rd S",
    city: "Lethbridge",
    region: "AB",
    country: "Canada",
    countryCode: "CA",
    postalCode: "T1K 8L8",
  },
  coordinates: {
    lat: 49.668048,
    lng: -112.786735,
  },
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d165240.92631353598!2d-112.7867350!3d49.6680480!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x536e87a27b83972f%3A0xc7752ee2a2beba8b!2sK%20Bakery!5e0!3m2!1sen!2sin!4v1760679630053!5m2!1sen!2sin",
};

export const bakeryAddress = `${businessInfo.address.street}, ${businessInfo.address.city}, ${businessInfo.address.region}, ${businessInfo.address.country}, ${businessInfo.address.postalCode}`;
